import { render, staticRenderFns } from "./Cambios.vue?vue&type=template&id=9be3ff16&scoped=true"
import script from "./Cambios.vue?vue&type=script&lang=js"
export * from "./Cambios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be3ff16",
  null
  
)

export default component.exports